export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes for login — openid/profile/email are standard OIDC scopes.
// The ID token returned is what we send to our backend for verification.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};
